
import LogsDS from '../../DataServices/LogsDs'; // ✅ fix path

const logs = new LogsDS();

export const insertLog = async (description, referralID,email, hud, stopHudRotation, showAlert) => {
  try {
    hud('Please Wait...');
    const requestData = {
      email,
      description,
      referralID
    };

    const response = await logs.RM_Activity_Logs_INSERT(requestData);
    const data = response.data;

    if (data.statusCode !== 200) {
      const message = data.body?.message || 'Log failed';
      showAlert && showAlert(message, [
        { label: 'Ok', onClick: () => {}, color: 'var(--buttonColor)' },
      ]);
    }
  } catch (error) {
    const message = error?.response?.data?.message || error.message || 'Logging error';
    showAlert && showAlert(message, [
      { label: 'Ok', onClick: () => {}, color: 'var(--buttonColor)' },
    ]);
  } finally {
    stopHudRotation();
  }
};
